import { ModuleFE_LogTemplate_OLD } from './ModuleFE_LogTemplate_OLD.js';
export const ModulePackFE_LogTemplateDB_OLD = [ModuleFE_LogTemplate_OLD];
//# sourceMappingURL=module-pack.js.map